import {
  START_TIMER,
  PAUSE_TIMER,
  RESTART_TIMER,
  STOP_TIMER,
  INCREMENT_TIMER,
  SET_TIMER_TASK,
  FETCH_TIMERS,
  NOTIFY_ADMIN_FINISHED
} from "../../_actions/types";

const defaultState = {
  isActiveTimer: false,
  startTime: null,
  elapsedTime: 0,
  canStartTimer: true,
  canPauseTimer: false,
  canStopTimer: false,
  location: "",
  allTimers: {}
};

export default function TimerReducer(state = defaultState, action) {
  switch (action.type) {
    case START_TIMER:
      if (!state.isActiveTimer) {
        // Start a new timer
        return {
          ...state,
          isActiveTimer: true,
          startTime: action.startTime,
          canStartTimer: false,
          canPauseTimer: true,
          canStopTimer: true,
          elapsedTime: 0
        };
      } else {
        // Restart the old timer
        return {
          ...state,
          canStartTimer: false,
          canPauseTimer: true,
          canStopTimer: true,
          activeTimerHandle: action.timerHandle
        };
      }

    case PAUSE_TIMER:
      return {
        ...state,
        canStartTimer: true,
        canPauseTimer: false,
        canStopTimer: true
      };

    case RESTART_TIMER:
      return {
        ...state,
        isActiveTimer: true,
        canStartTimer: false,
        canPauseTimer: true,
        canStopTimer: true
      };

    case INCREMENT_TIMER:
      return {
        ...state,
        elapsedTime: state.elapsedTime + action.amount
      };

    case SET_TIMER_TASK:
    console.log(action.userEmail);
      return {
        ...state,
        userEmail: action.userEmail,
        userId: action.userId, 
        title: action.title,
        key: action.key,
      };

    case STOP_TIMER:
      return {
        ...defaultState,
        allTimers: {
          ...state.allTimers,
          ...action.payload
        }
      };

    case FETCH_TIMERS:
      return { ...state, allTimers: action.payload };

    case NOTIFY_ADMIN_FINISHED:
      return { ...state };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/timetracker/timer_reducer.js